export enum URL_DEBUG_FLAGS {
  /**
   * When this flag is turned on the id's of products are shown. This is useful
   * in production since sometimes certain products or variations are misconfigured in product catalog
   * and by getting the ID we can quickly find the offending product.
   */
  SHOW_PRODUCT_IDS = 'show-product-ids',
  /**
   * DS3D includes a mechanism to filter out certain products from product catalog.
   * When this flag is enabled a series of verbose logs will be emitted on the console
   * which can help with diagnosing why filtering is not working as expected.
   */
  VERBOSE_PRODUCT_FILTERING = 'verbose-product-filtering',
}
